var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"menu-dropdown d-flex cursor-pointer",class:_vm.addClassStatus},[_c('div',{staticClass:"mx-2"},[_c('img',{attrs:{"src":_vm.selected.icon,"width":"13px"}})]),_vm._v(" "+_vm._s(_vm.selected.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }